<template>
  <div class="overflow: auto">
    <v-row class="ma-2 d-flex align-center">
      <v-col sm="4">
        <v-btn @click="$emit('back')" outlined>{{ $t("back_short") }}</v-btn>
      </v-col>
      <v-col sm="4" style>
        <h3 style="text-align: center">{{ $t("delivery_date") }}</h3>
      </v-col>
      <v-col sm="4" />
    </v-row>
    <div class="mt-2" style="overflow: auto; max-height: 400px">
      <v-col cols="12" class="mt-0">
        <calendar-field v-model="inputDate" :deliveryDateList="deliveryDateList"></calendar-field>
      </v-col>
    </div>
    <v-card-actions class="d-flex justify-center">
      <v-btn class="px-4" color="blue darken-1" outlined @click="clearModal">クリア</v-btn>
      <v-btn color="blue darken-1" depressed @click="$emit('click', {key: 'date', value: inputDate})">決定</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import CalendarField from "@/components/shared/CalendarField.vue";
import { localeDate } from "@/plugins/i18n";

export default {
  components: {
    CalendarField
  },
  props: {
    date: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      inputDate: null
    };
  },
  created() {
    this.inputDate = this.date;
  },
  methods: {
    localeDate,
    clearModal() {
      this.inputDate = null;
    },
  },
  computed: {
    deliveryDateList() {
      return this.$store.state.searchQuery.delivery_date_list;
    }
  }
};
</script>

<style scoped>

</style>
